import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Create,
  SimpleForm,
  ReferenceInput,
  AutocompleteInput,
  NumberInput,
  TextInput,
  DateInput,
  required,
  minValue,
} from "react-admin";
import type { CreateProps } from "react-admin";
import { redirectToProjectModuleDashboard } from "@/containers/projects/redirect-to-project-module-dashboard";
import { useRouteId } from "@/utils/route-utility";

export const ProjectPaymentCreate = (props: CreateProps) => {
  const [searchParams] = useSearchParams();
  const routeProjectId = useRouteId();
  const initialProjectId = useMemo(
    () => routeProjectId ?? searchParams.get("projectId") ?? undefined,
    [searchParams, routeProjectId]
  );
  const queryProjectId = searchParams.get("projectId");
  const redirectTo = useMemo(
    () => redirectToProjectModuleDashboard({ routeProjectId, queryProjectId, fallback: "list" }),
    [routeProjectId, queryProjectId]
  );

  return (
    <Create
      {...props}
      redirect={redirectTo}
      transform={(data: Record<string, unknown>) => ({
        projectId: routeProjectId ?? data.projectId,
        amount: Number(data.amount),
        paidDate: data.paidDate,
        payeeName:
          typeof data.payeeName === "string" ? data.payeeName.trim() || undefined : data.payeeName,
        purpose: typeof data.purpose === "string" ? data.purpose.trim() || undefined : data.purpose,
        paymentMode: String(data.paymentMode ?? "").trim(),
        paymentRef:
          typeof data.paymentRef === "string"
            ? data.paymentRef.trim() || undefined
            : data.paymentRef,
        remarks: typeof data.remarks === "string" ? data.remarks.trim() || undefined : data.remarks,
      })}
    >
      <SimpleForm defaultValues={{ projectId: initialProjectId, paymentMode: "Bank transfer" }}>
        {!routeProjectId && (
          <ReferenceInput source="projectId" reference="projects" perPage={100}>
            <AutocompleteInput optionText="name" label="Project" validate={required()} />
          </ReferenceInput>
        )}
        <NumberInput source="amount" validate={[required(), minValue(1)]} />
        <DateInput source="paidDate" validate={required()} />
        <TextInput source="payeeName" label="Payee / vendor" fullWidth />
        <TextInput source="purpose" label="Purpose / description" fullWidth multiline />
        <TextInput source="paymentMode" label="Payment mode" validate={required()} fullWidth />
        <TextInput source="paymentRef" label="Reference" fullWidth />
        <TextInput source="remarks" multiline fullWidth />
      </SimpleForm>
    </Create>
  );
};
